var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Smart Factory",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "page-tit-wrap"
  }, [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Smart Factory ")]), _c('p', [_vm._v(" 생산과정에 디지털 자동화 솔루션이 결합된 정보통신기술 (ICT)를 적용하여 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" loT를 통해 공정 데이터를 실시간 수집하고 스스로 분석하는 공정 도입 ")])])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "현장 데이터 집계"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-none d-md-block",
    attrs: {
      "src": "/images/sub/wwd/factory/factory-img1.png",
      "max-width": "946"
    }
  }), _c('v-img', {
    staticClass: "mx-auto d-block d-md-none",
    attrs: {
      "src": "/images/sub/wwd/factory/factory-img1-mo.png",
      "max-width": "484"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "데이터 집계 부서"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-none d-md-block",
    attrs: {
      "src": "/images/sub/wwd/factory/factory-img2.png",
      "max-width": "896"
    }
  }), _c('v-img', {
    staticClass: "mx-auto d-block d-md-none",
    attrs: {
      "src": "/images/sub/wwd/factory/factory-img2-mo.png",
      "max-width": "624"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }